import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/vision', label: 'Vision' },
];

export default function StaticNavigation() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <nav className="border-b border-white/10 bg-zapt-navy/95 backdrop-blur-md fixed top-0 w-full z-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="https://zapt-cdn.com/dc408fb4-e206-4be6-8677-dfc0f17d99f7/Zapt_White%2BLogo%2B(1).png" 
              alt="ZAPT" 
              className="h-10 sm:h-12 w-auto"
            />
          </Link>
          
          {/* Desktop navigation */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map(({ path, label }) => (
              <Link 
                key={path}
                to={path} 
                className={`transition-colors text-sm sm:text-base font-medium ${
                  currentPath === path 
                    ? 'text-zapt-yellow' 
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                {label}
              </Link>
            ))}
            <Link 
              to="/authenticate" 
              className="bg-zapt-yellow text-zapt-navy px-4 sm:px-5 py-2 sm:py-2.5 rounded-lg hover:bg-zapt-yellow/90 transition-colors text-sm sm:text-base font-bold"
            >
              Get Started
            </Link>
          </div>

          {/* Mobile navigation */}
          <div className="md:hidden flex items-center gap-3 sm:gap-4">
            {navLinks.map(({ path, label }) => (
              <Link 
                key={path}
                to={path} 
                className={`transition-colors text-xs sm:text-sm font-medium ${
                  currentPath === path 
                    ? 'text-zapt-yellow' 
                    : 'text-gray-400 hover:text-white'
                }`}
              >
                {label}
              </Link>
            ))}
            <Link 
              to="/authenticate" 
              className="bg-zapt-yellow text-zapt-navy px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg hover:bg-zapt-yellow/90 transition-colors text-xs sm:text-sm font-bold"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
